const E = "md", L = "xl", S = "lg", o = "sm";
export {
  S as LARGE_SCREEN,
  E as MOBILE_SCREEN,
  o as MOBILE_SMALL_SCREEN,
  L as SMALL_SCREEN
};
//# sourceMappingURL=screens.mjs.map
